import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { computeDetailActionTypes, computeDetailLoadingAction, computeDetailLoadedAction, } from '../ducks/ComputeDetail.ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import ComputeResource from '../../../Compute.resource';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { ApiErrorType } from '@ane/core/lib/models';
import { WorkspaceMigrationStatusCodes } from '@ane/core/lib/models/IAsyncWrapper/WorkspaceMigrationModels';
import { MigrationErrorMessages } from '@ane/core/lib/constants/WorkspaceMigration.constants';
const loadComputeArgs = {
    filterOnType: computeDetailActionTypes.LOAD,
    skiploadDataTransform: true,
    loadResource: (payload, state) => {
        return ComputeResource.getCompute(payload.workspaceId, payload.computeName);
    },
    loadingAction: computeDetailLoadingAction,
    loadedAction: (successData, payload, error) => {
        let errorContext = undefined;
        if (EnvironmentService.wsplitEnableRedirects() && successData.statusCode === WorkspaceMigrationStatusCodes.MovedPermanently) {
            /**
             * Workspace migration
             * 301 will not return error error context
             */
            errorContext = {
                statusCode: successData.statusCode,
                displayError: MigrationErrorMessages.MovedPerminenty,
                type: ApiErrorType.MovedPermanently,
                correlationId: 'No correlationId provided',
            };
        }
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData.getSuccessData(),
            error: error,
            errorContext,
        };
        return of(computeDetailLoadedAction(payload, result));
    },
};
export const loadComputeDetailEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadComputeArgs);
export default combineEpics(loadComputeDetailEpic);

//# sourceMappingURL=ComputeDetailEpic.js.map
